import React from "react";
import "./RecentOrders.css";

const RecentOrders = () => {
  return (
    <div className="list">
      <div className="box-title">
        <h1>Recent Orders</h1>
      </div>
      <div className="list__view__container">
        <div className="list__view" style={{ whiteSpace: "nowrap" }}>
          <table style={{ width: "100%", padding: 5 }}>
            <tr>
              <th>Id</th>
              <th>Amount</th>
              <th>Data</th>
              <th>Plan</th>
            </tr>
            <tr>
              <td>trans_QsrmQeShPN</td>
              <td>1GB</td>
              <td>$10</td>
              <td>Killer Elite</td>
            </tr>
            <tr>
              <td>trans_blxftYowmT</td>
              <td>1GB</td>
              <td>$2</td>
              <td>Killer Basic</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RecentOrders;
